import { UploadFileAPI } from '../../../api/genericLayout/UploadFileAPI';

export class UploadCommand {
    constructor(appName) {
        this.uploadFileApi = new UploadFileAPI(appName);
    }

    uploadFont(data, successCallback, errorCallback) {
        let dataToSend = new FormData();
        dataToSend.append("file", data.file);

        const apiResult = this.uploadFileApi.uploadFont(dataToSend);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback("Tipo de letra carregado com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a carregar o tipo de letra");
            }
        });
    }

    uploadLayout(data, successCallback, errorCallback) {
        let dataToSend = new FormData();
        dataToSend.append("file", data.file);

        const apiResult = this.uploadFileApi.uploadLayout(dataToSend);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback("Layout carregado com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a carregar o Layout");
            }
        });
    }
}
